import { Form } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import { customerBs } from '../CustomerBottomSheet';
import ServiceBottomSheet, { useServiceBottomSheet } from '../ServiceBottomSheet';
import ServiceByStaffStep, { ServiceByStaffStepRef } from '../ServiceByStaffStep';
import StaffBottomSheet, { useStaffBottomSheet } from '../StaffBottomSheet';
import { IGroupCustomerItem } from '../types';
import CustomerServices from './CustomerServices';
import ic_edit from './ic_edit.png';

type CustomerServicesStepProps = {
  value?: IGroupCustomerItem[];
}
type CustomerServicesStepRef = {
  fetch: (staffId: string) => void;
};
export const customerServicesStepRef = React.createRef<CustomerServicesStepRef>();
const CustomerServicesStep = forwardRef<CustomerServicesStepRef, CustomerServicesStepProps>(({ value: customers }, ref) => {
  const staffBs = useStaffBottomSheet();
  const serviceBs = useServiceBottomSheet();
  const form = Form.useFormInstance();
  const serviceByStaffStepRef = useRef<ServiceByStaffStepRef>(null);

  const onEditCustomerNums = async () => {
    const customers = form.getFieldValue('customers') || [];
    const customerName = form.getFieldValue('customerName') || '';
    try {
      const customerEditor = await customerBs.current?.open({ customerName, customers, numCustomers: customers?.length || 0 });
      if (!customerEditor) return;
      form.setFieldValue('customers', customerEditor.customers);
    } catch (error) {
      console.log('error', error);
    }
  };

  useImperativeHandle(ref, () => ({
    fetch: (staffId) => serviceByStaffStepRef.current?.fetch(staffId),
  }));

  if (customers?.length === 1) {
    return (
      <Form.List name={'customers'}>
        {(fields) => {
          return <>
            <ServiceByStaffStep ref={serviceByStaffStepRef} name={fields[0].name} />
          </>;
        }}
      </Form.List>
    );
  }

  return (
    <Container>
      <Form.Item noStyle shouldUpdate dependencies={['customers']}>
        {({ getFieldValue }) => {
          return (
            <div className="number-customer-row">
              <span className='label-num'>Number customers:</span>
              <button type='button' className='btn-edit-customer' onClick={onEditCustomerNums}>
                <span>{getFieldValue('customers')?.length || 0}</span>
                <img src={ic_edit} alt="ic_edit" style={{ width: '20px', height: '20px' }} />
              </button>
            </div>
          );
        }}
      </Form.Item>
      <Form.List name={'customers'}>
        {(fields) => {
          return <>
            <CustomerListStyled>
              {
                fields.map((field, index) => {
                  return <Form.Item key={field.key} name={field.name} noStyle>
                    <CustomerServices editName={false} customerLength={fields.length} name={field.name} index={index} serviceBs={serviceBs} staffBs={staffBs} />
                  </Form.Item>;
                })
              }
            </CustomerListStyled>
          </>;
        }}
      </Form.List>
      <StaffBottomSheet ref={staffBs} />
      <ServiceBottomSheet ref={serviceBs} />
    </Container>
  );
});
CustomerServicesStep.displayName = 'BookingV2CustomerServicesStep';
export default CustomerServicesStep;

const Container = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
.number-customer-row {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  .label-num {
    color: #1D2129;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .btn-edit-customer {
    display: flex;
    height: 32px;
    padding: 0 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background: #2463EB;
    span {
      color: #FFF;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    
  }
}
`;

export const CustomerListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
